
import { Component, Vue, Watch } from 'vue-property-decorator';
import ConversationData from '@/ts/ConversationData';
import { Mutations } from '@/ts/store/Constants';

@Component({
})
export default class MessageMethods extends Vue {
    // data
    get activeConversation(): ConversationData {
        return this.$store.getters['Messages/activeConversation'];
    }

    get conversations(): ConversationData[] {
        return this.$store.getters['Messages/conversationList'];
    }

    get closeConversations(): ConversationData[] {
        const closeConversations = this.conversations.filter((conversation: any) => {
            return (conversation.status === 'closed' && !conversation.external);
        });
        return closeConversations;
    }

    get openConversations(): ConversationData[] {
        const openConversations = this.conversations.filter((conversation: any) => {
            return (conversation.status === 'open' && !conversation.external);
        });
        return openConversations;
    }

    get externalConversations(): ConversationData[] {
        const externalConversations = this.conversations.filter((conversation: any) => {
            return (conversation.status === 'open' && conversation.external);
        });
        return externalConversations;
    }

    get conversationsStatus(): string {
        return this.$store.getters['Messages/getVisibleConversationsStatus'];
    }

    // getters
    get conversationList(): ConversationData[] {
        // Slice(0) is necessary because TS sort is in-place
        let clone = ((this.messageSearchTerms !== '') 
            ? this.filteredConversations
            : this.conversationsStatus === 'open' ? this.openConversations : this.conversationsStatus === 'all' ? this.externalConversations : this.closeConversations).slice(0);

        // Don't show hidden conversations
        clone = clone.filter((conversation) => {
            return (conversation.hidden === false);
        });

        // Return a time descending sorted version of the cloned array
        return clone.sort((a: ConversationData, b: ConversationData): number => {
            if (a.newestMessageTimestamp < b.newestMessageTimestamp) {
                return 1;
            }

            if (a.newestMessageTimestamp > b.newestMessageTimestamp) {
                return -1;
            }

            return 0;
        });
    }

    get messageDataLoaded(): boolean {
        return (this.conversations !== null);
    }

    get isSearching() {
        return this.$store.getters['vuexSearch/@@vuexSearch/getter/isSearching']('messages');
    }

    get searchResults() {
        return this.$store.getters['vuexSearch/@@vuexSearch/getter/result']('messages');
    }

    get messageSearchTerms(): string {
        return this.$store.getters['Messages/getConversationSearchTerm'];
    }

    set messageSearchTerms(value: string) {
        this.$store.commit(Mutations.UPDATE_CONVERSATION_SEARCH_TERM, value);
    }

    get filteredConversations() {
        return this.conversations.filter((conversation) => {
            return conversation.getSearchableText().indexOf(this.messageSearchTerms.toLowerCase()) > -1;
        });
    }

    public searchMessages(searchText: string) {
        this.$store.search.search('messages', searchText);
    }
}
